module.exports = __webpack_public_path__ + "static/media/laputa-back.144d5cb2.jpg";